import React, {Component} from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import GoogleIcon from 'resources/icons/google_icon.png'
import { FormField, Button, Divider, Spinner } from 'components'
import { GoogleButton } from 'features'

import * as actionCreators from 'store/actions'

const Container = styled.div`
    margin: 0.5rem 0;
    width: 100%;
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
    column-gap: 1rem;

`
const Error = styled.div`
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: var(--error-color);
`

const Wrapper = styled.div`
    display: flex;
    margin: 0.5rem;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const Text = styled.div`
    font-size: 0.8rem;
    margin: 0 0 0 0.5rem;
`

class RegisterScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: null,
            password: null,
            confirmPassword: null,
            selection: null,

            // email: 'bencryrus@hotmail.com',
            // password: 'asdasd',
            // confirmPassword: 'asdasd',
            errors: {
                email: null,
                password: null,
                confirmPassword: null,
                general: null
            }
        }
        this.props.authReset()
    }

    onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            this.submitForm()
        }
    }

    submitForm = ()  => {
        let updatedErrors = {
            email: null,
            password: null,
            general: null
        }
        // Email
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!this.state.email){
            updatedErrors['email'] = 'Please enter your email'
        } else if (!re.test(this.state.email)){
            updatedErrors['email'] = 'Please enter a valid email'
        }

        // Password
        if(!this.state.password || this.state.password.length === 0){
            updatedErrors['password'] = 'Please input your password'
        }

        // Confirm password
        if(!this.state.confirmPassword || this.state.confirmPassword.length === 0){
            updatedErrors['confirmPassword'] = 'Please re-enter your password'
        } else if (this.state.password !== this.state.confirmPassword){
            updatedErrors['confirmPassword'] = 'Passwords do not match'
        }
        
        if(!updatedErrors['email'] & !updatedErrors['password'] & !updatedErrors['confirmPassword']){
            this.props.signUpEmail(this.state.email, this.state.password)
        } 
        this.setState({
            errors: updatedErrors,
            submit: true
        })
        this.props.authReset()
    }

    googleSignUp = () => {
        this.props.signInThirdParty('GOOGLE')
        this.setState({
            googleSubmit: true
        })
    }
    
    render(){
        const googleIcon = <img src={GoogleIcon} style={{width:'1rem', height:'1rem',objectFit:'contain', marginRight: '0.5rem'}}/>
        const noErrors = !this.state.errors['email']
                    && !this.state.errors['password']
                    && !this.state.errors['confirmPassword']
                    && !this.state.errors['general']
                    && !this.props.error
        const showSpinner = this.state.submit && noErrors
        const showGoogleSpinner = this.state.googleSubmit && noErrors

        return(
            <Container>                
                {this.props.user && <Redirect to={this.props.redirectId ? `/login-desktop?id=${this.props.redirectId}` : '/loading'}/>}
                <FormField type='TEXT' label='Email' value={this.state.email} error={this.state.errors.email}
                    selected={this.state.selection === 'EMAIL'} onKeyDown={this.onKeyDownHandler}
                    onChange={(value) => {this.setState({email: value})}} onFocus={() => this.setState({selection: 'EMAIL'})} onBlur={() => this.setState({selection: null})}/>
                
                <FormField type='PASSWORD' label='Password' value={this.state.password} error={this.state.errors.password}
                    selected={this.state.selection === 'PASSWORD'} onKeyDown={this.onKeyDownHandler}
                    onChange={(value) => {this.setState({password: value})}} onFocus={() => this.setState({selection: 'PASSWORD'})} onBlur={() => this.setState({selection: null})}/>

                <FormField type='PASSWORD' label='Confirm password' value={this.state.confirmPassword} error={this.state.errors.confirmPassword}
                    selected={this.state.selection === 'CONFIRM_PASSWORD'} onKeyDown={this.onKeyDownHandler}
                    onChange={(value) => {this.setState({confirmPassword: value})}} onFocus={() => this.setState({selection: 'CONFIRM_PASSWORD'})} onBlur={() => this.setState({selection: null})}/>

                <Button text={!showSpinner && 'Register'} icon={showSpinner && <Spinner styles={{color: 'var(--text-color)'}}/>}
                    onSelect={this.submitForm}
                    styles={{backgroundColor: 'var(--focus-color)', margin: '1rem 0 0 0', height: '1.5rem', fontWeight: 'bolder'}}/>
                {this.state.errors['general'] || this.props.error && <Error>{this.props.error || this.state.errors['general']}</Error>}

                <Divider label='Or' style={{width: '50%', margin: '1rem 0'}}/>
                
                <Button icon={showGoogleSpinner ? <div style={{margin: '0 0.5rem'}}><Spinner styles={{color: 'var(--focus-color)'}}/></div>: googleIcon} text='Continue with Google' 
                        styles={{backgroundColor: '#fff', color: '#000', hoverColor: '#000', width: '100%', height: '1rem', padding: '0.5rem 0', margin: '0', brightness: '0.95'}}
                        onSelect={this.googleSignUp}/>
                {/* <GoogleButton text='Sign up with Google' onSelect={this.googleSignUp}/>
                {showGoogleSpinner && 
                <Wrapper>
                    <Spinner styles={{color: 'var(--focus-color)'}}/>
                    <Text>Registering</Text>
                </Wrapper>} */}
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        error: state.auth.error,
        user: state.auth.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        signUpEmail: (email, password) => dispatch(actionCreators.signUpEmail(email, password)),
        signInThirdParty: (type) => dispatch(actionCreators.signInThirdParty(type)),
        authReset: () => dispatch(actionCreators.authReset())
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( RegisterScreen ); 